var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { observable } from "mobx";
import { entities } from "sb-bff-integration";
import { MarketTemplate, SelectionType, CardType } from "../../data";
import { selectionsOrdering, emptySelectionPointBox } from "../../constants";
import { findSelectionsOrdering, mapSelections, StaticDecimalLocalizator } from "..";
import { isNumber } from "util";
/**
 * Order selections in markets for specific sport
 * @param selections
 * @param template
 */
export var fillEmptySelections = function (selections, template, cardType) {
    var types = getSelectionTypes(selections);
    var type = pickSelectionType(types);
    var selectionType = findSelectionsType(selections);
    var orderIndex = findSelectionsOrdering(template, type);
    var order = selectionsOrdering[template][orderIndex];
    var selectionsSet = [];
    if (MarketTemplate[template] === MarketTemplate.ThreeBox) {
        selectionsSet = mapSelections(selections, order);
        selectionsSet = addPointsText(selectionsSet, cardType, selectionType);
        return observable.array(selectionsSet);
    }
    selectionsSet = getSelections(selections);
    var tempSet = selectionsSet.length ? selectionsSet : selections;
    if (MarketTemplate[template] === MarketTemplate.PointBox) {
        selectionsSet = __spread([__assign({}, emptySelectionPointBox)], mapSelections(tempSet, order));
        selectionsSet[0].points = getPoints(selections);
    }
    else {
        selectionsSet = mapSelections(tempSet, order);
    }
    selectionsSet = addPointsText(selectionsSet, cardType, selectionType);
    return observable.array(selectionsSet);
};
/**
 * Pick selection outcomeType to use for ordering find
 * @param types
 */
var pickSelectionType = function (types) {
    return types.find(function (t) { return t === entities.OutcomeType.Draw || t === entities.OutcomeType.Tie; }) || types[0];
};
/**
 * Gather all selection outcomeTypes into array
 * @param selections
 */
var getSelectionTypes = function (selections) {
    var result = [];
    selections.forEach(function (s) { return s.outcomeType && result.push(s.outcomeType); });
    return result;
};
/**
 * Get selection for types HC or OU
 * @param selections
 */
var getSelections = function (selections) {
    var selectionsSet = [];
    var type = findSelectionsType(selections);
    var mainLineSelections = [];
    type && (mainLineSelections = filterByMainPointLine(selections));
    selectionsSet = mainLineSelections.length
        ? mainLineSelections
        : reduceSelections(selections);
    return selectionsSet;
};
/**
 * Find if selections are of type HC or OU
 * @param selections
 */
var findSelectionsType = function (selections) {
    return (selections.find(function (s) { return s.outcomeType === "Over"; })
        ? SelectionType.OU
        : selections.find(function (s) { return s.outcomeType === "Home"; })
            ? SelectionType.HC
            : undefined);
};
/**
 * Get all selections with tag of "MainPointLine"
 * @param selections
 */
export var filterByMainPointLine = function (selections) {
    if (selections.length === 2) {
        return selections;
    }
    return selections.filter(function (s) { return s && s.tags && s.tags.indexOf("MainPointLine") > -1; });
};
/**
 * Reduce selections to show, in case of no MainPointLine selections
 * @param selections
 * @param type
 */
export var reduceSelections = function (selections) {
    var reduced = [];
    var firstSelectionWithPoints = selections.find(function (s) { return isNumber(s.points); });
    return !firstSelectionWithPoints
        ? reduced
        : pickSelectionsByPoints(firstSelectionWithPoints, selections);
};
/**
 * Use s1 points to find another selection with the same points
 * @param s1
 * @param selections
 */
var pickSelectionsByPoints = function (s1, selections) {
    var reduced = [s1];
    var s2 = selections.find(function (s) { return isNumber(s.points)
        && s.id !== s1.id
        && Math.abs(s.points) === (s1.points && Math.abs(s1.points)); });
    s2 && reduced.push(s2);
    return reduced;
};
/**
 * Get points to assign to pointsText
 * @param selections
 */
export var getPoints = function (selections) {
    if (selections.length === 2) {
        return selections[0].points || 0;
    }
    var s = selections.find(function (s) { return s.points !== null && s.tags && s.tags.indexOf("MainPointLine") > -1; }) || selections.find(function (s) { return isNumber(s.points); });
    return s && s.points ? s.points : 0;
};
/**
 * Assign points value to pointsText
 * @param selections
 */
var addPointsText = function (selections, cardType, selectionType) {
    var checkTypes = (cardType === CardType.American && selectionType === SelectionType.HC);
    selections.forEach(function (s) {
        if (s.points === null || s.points === undefined) {
            s.pointsText = "";
            return s;
        }
        var sign = checkTypes && s.points > 0 ? "+" : "";
        s.pointsText = "" + sign + localizePoint(s.points);
        return s;
    });
    return selections;
};
var localizePoint = function (point) {
    var localizator = StaticDecimalLocalizator.getInstance();
    return typeof localizator !== "undefined" ? localizator.localizePoint(point) : point.toString();
};
//# sourceMappingURL=fillEmptySelections.js.map